/**
 * Doing this because rendering Select is SLOW.
 */
import React from 'react';
import { Select } from 'semantic-ui-react';

const RawMySelect = (props) => <Select noResultsMessage='找不到結果'placeholder=""  {...props}/>

export default React.memo(RawMySelect);